import { useAuth0 } from '@auth0/auth0-vue';
import { UserTokenUtils } from '@purepm/fs-common';
import { getDataAccessClaim, getDefaultOrgUnits, getRolesAndPersonaForDefaultOrgUnit, getUserProfile } from '.';
import CONFIG from '../../helpers/config';
export const log_prefix = `[lib: common]`;
export const getAuth0Objects = () => {
    try {
        const auth0 = useAuth0();
        if (!auth0) {
            return {
                isAuthenticated: { value: false },
                isLoading: { value: true },
                error: { value: null },
            };
        }
        const { isLoading, isAuthenticated, error } = auth0;
        return { isAuthenticated, isLoading, error };
    }
    catch (error) {
        console.error('Error:', error);
        return {
            isAuthenticated: { value: false },
            isLoading: { value: true },
            error: { value: null },
        };
    }
};
export const getUserDataAccessDetails = (auth0) => {
    // console.log('[getUserDataAccessDetails]');
    const { user_profile } = getUserProfile(auth0);
    const auth0_audience_namespace = CONFIG.AUTH0_AUDIENCE;
    const data_access_key = `${auth0_audience_namespace}/data_access`;
    // console.debug(`[getUserDataAccessDetails]`, {
    // user_profile,
    //   auth0_audience_namespace,
    //   data_access_key,
    // });
    let data_access;
    let email;
    if (user_profile) {
        // console.debug(`[getUserDataAccessDetails] if user_profile`);
        email = user_profile.email;
        ({ data_access } = UserTokenUtils.getDataAccessClaimFromUserProfile(user_profile, data_access_key));
    }
    else {
        // console.debug(`[getUserDataAccessDetails] else user_profile`);
        ({ data_access } = getDataAccessClaim());
    }
    // console.debug(`[getUserDataAccessDetails]`, {
    //   data_access,
    // });
    const employee_data_access = data_access;
    if (employee_data_access) {
        const { user_level, corporation_id, person_id, default_brand_id } = employee_data_access;
        const default_org_units = getDefaultOrgUnits(auth0);
        const { persona, roles: user_roles } = getRolesAndPersonaForDefaultOrgUnit(auth0);
        // console.debug(`[getUserDataAccessDetails] Returning`, {
        //   email,
        //   user_level,
        //   corporation_id,
        //   person_id,
        //   persona,
        //   user_roles,
        //   default_org_units,
        // });
        return { email, user_level, corporation_id, person_id, persona, user_roles, default_org_units, default_brand_id };
    }
    else {
        throw new Error('Error getting details from user profile and data_access');
    }
};
const isEmail = (value) => !!value && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
export const getDisplayName = (user) => {
    const { name, given_name, family_name, email } = user;
    // Use if it's a proper name
    if (name && name.trim() && !isEmail(name))
        return name.trim();
    const givenName = given_name?.trim();
    const familyName = family_name?.trim();
    // Use given_name and family_name as name if they exist
    const combined = [givenName, familyName].filter(Boolean).join(' ');
    if (combined)
        return combined;
    return email || '';
};
export const getInitials = (user) => {
    const { given_name, family_name, name, email } = user;
    // Use if it's a proper name
    if (name && name.trim() && !isEmail(name)) {
        const parts = name.trim().split(/\s+/);
        // For multiple words, use first letter of first + last word (ignoring middle names)
        return parts.length > 1
            ? (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
            : parts[0][0]?.toUpperCase() || '';
    }
    const givenName = given_name?.trim();
    const familyName = family_name?.trim();
    if (givenName || familyName) {
        // Take first letter of each name part, handling cases where one might be missing
        const first = givenName?.[0] || '';
        const last = familyName?.[0] || '';
        return (first + last).toUpperCase();
    }
    return email?.[0]?.toUpperCase() || '';
};
